/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';

import * as Roles from '../../constants/role';
import * as selectorsProgramacaoDiarias from '../../store/programacaoDiaria/reducer';
import * as actionsProgramacaoDiarias from '../../store/programacaoDiaria/actions';
import * as selectorsAuth from '../../store/auth/reducer';

import moment from 'moment';

import { Input, DialogDefault, DatePicker, UsuarioSelect, OptionSelect, NsirSelect, VeiculoSelect } from '../../components';
import { TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO, TIPO_PROGRAMACAO_DIARIA_INSPECAO, TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS } from '../../constants/ids';
import { buildRequiredSchema } from 'utils';

const getSchema = data => {
    let schema = buildRequiredSchema(['data', 'inspetorId']);
    if (TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO === data.tipoId) return { ...schema, ...buildRequiredSchema(['cidadeDe', 'cidadePara']) };
    if (TIPO_PROGRAMACAO_DIARIA_INSPECAO === data.tipoId) return { ...schema, ...buildRequiredSchema(['nsirIds']) };
    if (TIPO_PROGRAMACAO_DIARIA_INSPECAO === data.tipoId) return { ...schema, ...buildRequiredSchema(['veiculoId']) };

    return schema;
  };

const useStyles = makeStyles(() => ({
  gridContainer: {
    marginTop: 0
  },
  fieldContainer: {
    paddingBottom: '0px !important'
  },
}));

const Formulario = ({ saveProgramacaoDiaria, updateProgramacaoDiaria, selectedProgramacaoDiaria, open, id, onClose, 
  findProgramacaoDiariaById, authData, isAdmin }) => {

  const classes = useStyles();

  const [values, setValues] = useState({ data: moment().valueOf() });
  const [errors, setErrors] = useState({});
  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    if (id) findProgramacaoDiariaById(id);
  }, [id, findProgramacaoDiariaById]);

  useEffect(() => {
    if (id && selectedProgramacaoDiaria && id === selectedProgramacaoDiaria.id) {
      if (!selectedProgramacaoDiaria.data) selectedProgramacaoDiaria.data = moment().valueOf();
      else selectedProgramacaoDiaria.data = Number(selectedProgramacaoDiaria.data);
      setValues(selectedProgramacaoDiaria);
      setReadOnly(selectedProgramacaoDiaria.readOnly);
    } else {
      setValues({ data: moment().valueOf() });
      setReadOnly(false);
    }
  }, [id, selectedProgramacaoDiaria]);

  const onSave = () => {
    const erros = validate(values, getSchema(values));
    setErrors(erros);

    if (!erros) {
      if (values.id) updateProgramacaoDiaria(values, saveCallback);
      else saveProgramacaoDiaria(values, saveCallback);
    }
  }

  const saveCallback = success => {
    if (success) {
      onCloseLocal(true);
    }
  }

  const onCloseLocal = isSave => {
    setErrors({});
    setValues({})
    onClose(isSave);
  }

  const handleChange = event => setValues({ ...values, [event.target.name]: event.target.value });

  console.log(values)

  return (
    <DialogDefault
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Programação Diária"
      confirmMessage="Salvar"
      contentClassName={classes.contentClassName}
      maxWidth="md"
      readOnly={readOnly}
    >
      <Grid container spacing={3} className={classes.gridContainer}>
        <Grid item xs={6} className={classes.fieldContainer}>
          <DatePicker
            label="Data"
            isRequired
            onChange={data => setValues({
              ...values,
              data: data.valueOf()
            })}
            value={values.data}
            disabled={readOnly}
            error={errors && errors.data}
          />
        </Grid>
        <Grid item xs={6} className={classes.fieldContainer}>
          <Input
            label="Data Inclusão"
            disabled
            value={values.dataInclusao}
          />
        </Grid>
        <Grid item xs={6} className={classes.fieldContainer}>
          <UsuarioSelect
            label="Inspetor"
            isRequired
            onSelect={inspetorId => setValues({ ...values, inspetorId })}
            ativo
            grupos={[Roles.ADMIN, Roles.INSPETOR]}
            value={values.inspetorId}
            disabled={readOnly}
            error={errors && errors.inspetorId}
            helperText={errors && errors.inspetorId ? errors.inspetorId : null}
          />
        </Grid>
        <Grid item xs={6} className={classes.fieldContainer}>
          <UsuarioSelect
            label="Ajudante/Observador"
            onSelect={inspetorAuxiliarId => setValues({ ...values, inspetorAuxiliarId })}
            ativo
            grupos={[Roles.ADMIN, Roles.INSPETOR]}
            value={values.inspetorAuxiliarId}
            disabled={readOnly}
          />
        </Grid>
        <Grid item xs={6}>
          <OptionSelect
            label="Tipo da Programação"
            codigo="TIPO_PROGRAMACAO_DIARIA"
            isRequired
            onSelect={(tipoId) => setValues({ ...values, tipoId })}
            value={values.tipoId}
            disabled={readOnly}
            error={errors && errors.tipoId}
            helperText={errors && errors.tipoId ? errors.tipoId : null}
          />
        </Grid>
        {TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO === values.tipoId && <>
          <Grid item xs={6} className={classes.fieldContainer} />
          <Grid item xs={6} className={classes.fieldContainer}>
            <Input
              error={errors && errors.cidadeDe}
              helperText={errors && errors.cidadeDe ? errors.cidadeDe : null}
              label="Cidade De"
              name="cidadeDe"
              onChange={handleChange}
              value={values.cidadeDe}
              disabled={readOnly}
              isRequired={TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO === values.tipoId}
            />
          </Grid>
          <Grid item xs={6} className={classes.fieldContainer}>
            <Input
              error={errors && errors.cidadePara}
              helperText={errors && errors.cidadePara ? errors.cidadePara : null}
              label="Cidade Para"
              name="cidadePara"
              onChange={handleChange}
              value={values.cidadePara}
              disabled={readOnly}
              isRequired={TIPO_PROGRAMACAO_DIARIA_DESLOCAMENTO === values.tipoId}
            />
          </Grid>
        </>}
        {TIPO_PROGRAMACAO_DIARIA_INSPECAO === values.tipoId && <>
          <Grid item xs={12} className={classes.fieldContainer}>
            <NsirSelect
              onSelect={(nsirIds) => setValues({ ...values, nsirIds })}
              value={values.nsirIds}
              multiSelect
              disabled={readOnly}
              isRequired={TIPO_PROGRAMACAO_DIARIA_INSPECAO === values.tipoId}
              error={errors && errors.nsirIds}
              helperText={errors && errors.nsirIds ? errors.nsirIds : null}
            />
          </Grid>
        </>}
        {TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS === values.tipoId && <>
          <Grid item xs={12} className={classes.fieldContainer}>
            <VeiculoSelect
              onSelect={veiculoId => setValues({ ...values, veiculoId })}
              value={values.veiculoId}
              disabled={readOnly}
              isRequired={TIPO_PROGRAMACAO_DIARIA_MANUTENCAO_VEICULOS === values.tipoId}
              error={errors && errors.nsirIds}
              helperText={errors && errors.nsirIds ? errors.nsirIds : null}
            />
          </Grid>
        </>}
        <Grid item xs={12} className={classes.fieldContainer}>
          <Input
            error={errors && errors.descricao}
            helperText={errors && errors.descricao ? errors.descricao : null}
            isRequired={TIPO_PROGRAMACAO_DIARIA_INSPECAO === values.tipoId}
            label="Descrição"
            name="descricao"
            onChange={handleChange}
            value={values.descricao}
            rows={3}
            multiline
            disabled={readOnly}
          />
        </Grid>
      </Grid>
    </DialogDefault>
  );
};

Formulario.propTypes = {
  findProgramacaoDiariaById: PropTypes.func.isRequired, 
  saveProgramacaoDiaria: PropTypes.func.isRequired,
  updateProgramacaoDiaria: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired, 
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  selectedProgramacaoDiaria: PropTypes.object
};

Formulario.defaultValue = {
  selectedProgramacaoDiaria: null,
  id: null,
}

const mapStateToProps = state => ({
  selectedProgramacaoDiaria: selectorsProgramacaoDiarias.getSelectedProgramacaoDiaria(state),
  authData: selectorsAuth.getAuth(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsProgramacaoDiarias,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
